var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        "custom-class": "ai-trust-from-window",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.AssociationBusinessInformation"),
        "close-on-click-modal": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          _vm.innerVisible = false
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _vm.showRevokeButton
          ? _c(
              "div",
              { staticStyle: { "padding-bottom": "5px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "revoke", type: "danger" },
                    on: { click: _vm.revokeJobHandler }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_WithdrawTheEntrustment"))
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            class:
              "tabs-container" +
              (_vm.canOperateJob ? "" : " cannot-operate-job")
          },
          [
            _c("span", { staticClass: "lab-state" }, [
              _vm._v(_vm._s(_vm.labState))
            ]),
            _c(
              "el-tabs",
              {
                ref: "tabs",
                attrs: { type: "card" },
                on: { "tab-click": _vm.handleTabClick },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _vm.currentRow && !_vm.currentRow.masterFlag
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 101,
                        attrs: {
                          name: "basicTab",
                          label: _vm.$t("SeaExport.Basic")
                        }
                      },
                      [
                        _c("basic-tab", {
                          ref: "basicTab",
                          attrs: { context: _vm.context, action: _vm.action }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentRow && _vm.currentRow.masterFlag
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 102,
                        attrs: {
                          name: "masterBasicTab",
                          label: _vm.$t("SeaExport.Basic")
                        }
                      },
                      [
                        _c("master-basic-tab", {
                          ref: "masterBasicTab",
                          attrs: {
                            context: _vm.context,
                            action: _vm.action,
                            "view-source": "bookingWorkspace"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-tab-pane",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_AEBooking_portalState"],
                        expression: "['button_AEBooking_portalState']"
                      }
                    ],
                    key: 103,
                    attrs: {
                      name: "tabSopState",
                      label: _vm.$t("SeaExport.BusinessStatus")
                    }
                  },
                  [
                    _c("tab-sop-state", {
                      ref: "tabSopState",
                      attrs: {
                        context: _vm.context,
                        action: _vm.action,
                        "show-button": _vm.showButton
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    key: 104,
                    attrs: {
                      name: "tabFileHistory",
                      label: _vm.$t("SeaExport.FileHistory")
                    }
                  },
                  [
                    _c("tab-file-history", {
                      ref: "tabFileHistory",
                      attrs: {
                        context: _vm.context,
                        action: _vm.action,
                        "show-button": _vm.showButton,
                        "can-operate-job": _vm.canOperateJob
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }